module.exports = __webpack_public_path__ + "static/img/icon4.3186bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/winning/icon4.png
// module id = zZUQ
// module chunks = 6